export default "__VITE_ASSET__CJjlzqjs__"